import { useMemo } from 'react';
import { z } from 'zod';
import { buildZodSchema } from 'redesign';
import { DocumentModel } from '@types';
import { useTranslation } from 'react-i18next';

export const useCreateEditDocumentFormSchema = (formDataModel: DocumentModel[string]) => {
  const { t } = useTranslation(['hq-screen-specific']);
  const selectedSchema = formDataModel?.actions?.edit ?? {
    items: [],
    rules: [],
  };

  const formSchema = useMemo(() => {
    const baseSchema = z.object({
      name: z.string().min(1, {
        message: t('document_edit.form.name_label', {
          ns: 'hq-screen-specific',
        }),
      }),
    });

    return buildZodSchema(selectedSchema.items, selectedSchema.rules, (dynamicSchema) =>
      baseSchema.merge(dynamicSchema)
    );
  }, [formDataModel, t]);

  return formSchema;
};
